import {setAmplitudeUserProperties, trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";
import {
    AmplitudeUnlockChoiceButtonAction,
    AmplitudeUnlockChoiceExitButtonName,
    trackAmplitudeButtonClick
} from "../../tracking/amplitude/track_amplitude_button_click";
import {AmplitudeModalLocation, AmplitudeModalName, trackAmplitudeViewModal} from "../../tracking/amplitude/track_amplitude_view_modal";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {serializeHomeMatchPreferences} from "../../user/tracking/amplitude/track_multilead_preferences_events";
import {IPreferencesDefaultValues} from "../../user/types/IPreferencesDefaultValues";
import {UNLOCK_CHOICE_TRACKING} from "../constants/unlock_choice_tracking";
import {UnlockChoiceOptionId} from "../types/IUnlockChoiceOption";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

export interface UnlockChoiceTrackingContext {
    entryPoint: UnlockChoiceEntryPoint;
    authPlacement: AmplitudeAuthPlacement | null;
    location: AmplitudeModalLocation;
    itemId: number | null;
    propertyId: number | null;
}

interface UnlockChoicePreferencesSavedParams {
    values: IPreferencesDefaultValues;
    autoMatchEnabled: boolean;
    regionDetails?: IRegionListRegion[];
}

export const trackUnlockChoiceModalView = (
    context: UnlockChoiceTrackingContext,
    modalName: AmplitudeModalName = UNLOCK_CHOICE_TRACKING[context.entryPoint].modalName
) => {
    trackAmplitudeViewModal({
        modalName,
        location: context.location,
        authPlacement: context.authPlacement,
        itemId: context.itemId,
        propertyId: context.propertyId
    });
};

export const trackUnlockChoiceButtonClick = (
    context: UnlockChoiceTrackingContext,
    action: AmplitudeUnlockChoiceButtonAction,
    optionId: UnlockChoiceOptionId
) => {
    const {buttonCategory, values} = UNLOCK_CHOICE_TRACKING[context.entryPoint];

    trackAmplitudeButtonClick({
        buttonName: `${buttonCategory}_${action}`,
        buttonCategory,
        itemId: context.itemId,
        propertyId: context.propertyId,
        value: values[optionId] ?? null,
        additionalEventProperties: {auth_placement: context.authPlacement}
    });
};

/** The steps after the choice keep the category of its modal - the exit step is told by the `…_close` sent before them */
export const trackUnlockChoiceExitButtonClick = (context: UnlockChoiceTrackingContext, buttonName: AmplitudeUnlockChoiceExitButtonName) => {
    trackAmplitudeButtonClick({
        buttonName,
        buttonCategory: UNLOCK_CHOICE_TRACKING[context.entryPoint].buttonCategory,
        itemId: context.itemId,
        propertyId: context.propertyId,
        additionalEventProperties: {auth_placement: context.authPlacement}
    });
};

export const trackUnlockChoicePreferencesSaved = (context: UnlockChoiceTrackingContext, params: UnlockChoicePreferencesSavedParams) => {
    const {buttonCategory} = UNLOCK_CHOICE_TRACKING[context.entryPoint];
    const preferences = serializeHomeMatchPreferences(params.values, params.regionDetails);

    trackAmplitudeEvent("hm_preferences_saved", {
        location: buttonCategory,
        button_category: buttonCategory,
        auth_placement: context.authPlacement,
        item_id: context.itemId,
        property_id: context.propertyId,
        ...preferences,
        rp_auto_match_enabled: params.autoMatchEnabled
    });
    setAmplitudeUserProperties(preferences);
};
import {setAmplitudeUserProperties, trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";
import {
    AmplitudeUnlockChoiceButtonAction,
    AmplitudeUnlockChoiceExitButtonName,
    trackAmplitudeButtonClick
} from "../../tracking/amplitude/track_amplitude_button_click";
import {AmplitudeModalLocation, AmplitudeModalName, trackAmplitudeViewModal} from "../../tracking/amplitude/track_amplitude_view_modal";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {serializeHomeMatchPreferences} from "../../user/tracking/amplitude/track_multilead_preferences_events";
import {IPreferencesDefaultValues} from "../../user/types/IPreferencesDefaultValues";
import {UNLOCK_CHOICE_TRACKING} from "../constants/unlock_choice_tracking";
import {UnlockChoiceOptionId} from "../types/IUnlockChoiceOption";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

export interface UnlockChoiceTrackingContext {
    entryPoint: UnlockChoiceEntryPoint;
    authPlacement: AmplitudeAuthPlacement | null;
    location: AmplitudeModalLocation;
    itemId: number | null;
    propertyId: number | null;
}

interface UnlockChoicePreferencesSavedParams {
    values: IPreferencesDefaultValues;
    autoMatchEnabled: boolean;
    regionDetails?: IRegionListRegion[];
}

export const trackUnlockChoiceModalView = (
    context: UnlockChoiceTrackingContext,
    modalName: AmplitudeModalName = UNLOCK_CHOICE_TRACKING[context.entryPoint].modalName
) => {
    trackAmplitudeViewModal({
        modalName,
        location: context.location,
        authPlacement: context.authPlacement,
        itemId: context.itemId,
        propertyId: context.propertyId
    });
};

export const trackUnlockChoiceButtonClick = (
    context: UnlockChoiceTrackingContext,
    action: AmplitudeUnlockChoiceButtonAction,
    optionId: UnlockChoiceOptionId
) => {
    const {buttonCategory, values} = UNLOCK_CHOICE_TRACKING[context.entryPoint];

    trackAmplitudeButtonClick({
        buttonName: `${buttonCategory}_${action}`,
        buttonCategory,
        itemId: context.itemId,
        propertyId: context.propertyId,
        value: values[optionId] ?? null,
        additionalEventProperties: {auth_placement: context.authPlacement}
    });
};

/** The steps after the choice keep the category of its modal - the exit step is told by the `…_close` sent before them */
export const trackUnlockChoiceExitButtonClick = (context: UnlockChoiceTrackingContext, buttonName: AmplitudeUnlockChoiceExitButtonName) => {
    trackAmplitudeButtonClick({
        buttonName,
        buttonCategory: UNLOCK_CHOICE_TRACKING[context.entryPoint].buttonCategory,
        itemId: context.itemId,
        propertyId: context.propertyId,
        additionalEventProperties: {auth_placement: context.authPlacement}
    });
};

export const trackUnlockChoicePreferencesSaved = (context: UnlockChoiceTrackingContext, params: UnlockChoicePreferencesSavedParams) => {
    const {buttonCategory} = UNLOCK_CHOICE_TRACKING[context.entryPoint];
    const preferences = serializeHomeMatchPreferences(params.values, params.regionDetails);

    trackAmplitudeEvent("hm_preferences_saved", {
        location: buttonCategory,
        button_category: buttonCategory,
        auth_placement: context.authPlacement,
        item_id: context.itemId,
        property_id: context.propertyId,
        ...preferences,
        rp_auto_match_enabled: params.autoMatchEnabled
    });
    setAmplitudeUserProperties(preferences);
};
